<div id="root">
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeForm()"></button>
  <div class="App-Container is-darkBackground App-Container--noAnimation flex-container justify-content-center prospect-form" data-testid="checkout-container">
    <div class="App App--multiItem">
      <div class="App-Overview is-darkBackground" style="background-color: rgb(18, 18, 18);">
        <img class="Prospect-Logo" src="/assets/images/bg/prospect-form.webp" alt="Drop Logo" width="100" />
      </div>
      <div class="App-Payment">
        <main>
          <div class="CheckoutPaymentForm">
            <div style="height: 36.7969px;">
              <div>
                <div class="PaymentRequestOrHeader" style="display: inherit; height: auto;">
                  <div class="AnimateSinglePresence">
                    <div class="AnimateSinglePresenceItem">
                      <div>
                        <div class="PaymentHeaderContainer" style="display: block; opacity: 1;">
                          
                        </div>
                        <div class="ButtonAndDividerContainer" style="display: none; opacity: 0; height: 0px;">
                          <div class="ButtonContainer">
                            <div class="ButtonWrapper">
                              <div class="ButtonWrapper"></div>
                            </div>
                          </div>
                          <div></div>
                          <div class="Divider">
                            <hr>
                            <p class="Divider-Text Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400"><span class="DividerText">Or pay another way</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form class="PaymentForm-form" novalidate="" *ngIf="prospectForm" [formGroup]="prospectForm" (ngSubmit)="onSubmit()">
              <input type="hidden" formControlName="LocationId" />
              <input type="hidden" formControlName="PaymentMethod" />
              <div class="" style="position: relative;">
                <div class="flex-container spacing-16 direction-column wrap-wrap">
                  <div class="flex-item width-12">
                    <div class="FormFieldGroup" data-qa="FormFieldGroup-email">
                      <div class="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                        <label for="email-fieldset">
                          <span class="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">Contact information</span></label>
                        <div style="opacity: 1; transform: none;"></div>
                      </div>
                      <fieldset class="FormFieldGroup-Fieldset" id="firstName-fieldset">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="FormFieldGroup-container">
                              <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                                <div class="form-floating">
                                  <input #email type="text" name="FirstName" formControlName="FirstName" class="form-control" id="FirstName" placeholder="FirstName" required autofocus (focusout)="validateField('FirstName')" />
                                  <label for="FirstName">First Name</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="FormFieldGroup-container LastNameField">
                              <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                                <div class="form-floating">
                                  <input #email type="text" name="LastName" formControlName="LastName" class="form-control" id="LastName" placeholder="LastName" required autofocus (focusout)="validateField('LastName')" />
                                  <label for="LastName">Last Name</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="email-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <input #email type="email" name="email" formControlName="Email" class="form-control" id="email" placeholder="Email" required autofocus (focusout)="validateField('Email')" />
                              <label for="email">Email</label>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="phoneNumber-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childBottom">
                            <div class="FormFieldInput">
                              <div class="PhoneNumberInput">
                                <div class="input-group has-validation">
                                  <span class="input-group-text" (click)="country.open(countryCode, phone)">
                                    <img [src]="flagUrl" class="flag">
                                    <span class="px-1">{{dialCode}}</span>
                                  </span>
                                  <div class="form-floating">
                                    <input #phone type="tel" name="phone" formControlName="PhoneNumber" class="form-control" id="phone" placeholder="Mobile Number" required autofocus (focusout)="validateField('PhoneNumber')" />
                                    <label for="phone">Phone Number</label>
                                  </div>
                                  <div class="invalid-feedback">
                                    Please enter a phone number.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="email-notification-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <div class="CheckboxField">
                                <div class="Checkbox">
                                  <div class="Checkbox-InputContainer">
                                    <input #emailNotification type="checkbox" name="emailNotification" formControlName="EmailNotification" id="emailNotification" placeholder="Email Notification" autofocus class="Checkbox-Input" (change)="onTermsOfServiceChange($event)" />
                                  </div>
                                  <div><label for="emailNotification"><span class="Checkbox-Label Text Text-color--gray900 Text-fontSize--13 Text-fontWeight--500">Email me with news and updates</span></label></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="sms-notification-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <div class="CheckboxField">
                                <div class="Checkbox">
                                  <div class="Checkbox-InputContainer">
                                    <input #smsNotification type="checkbox" name="smsNotification" formControlName="SmsNotification" id="smsNotification" placeholder="Sms Notification" autofocus class="Checkbox-Input" (change)="onSmsNotificationChange($event)" />
                                  </div>
                                  <div><label for="smsNotification"><span class="Checkbox-Label Text Text-color--gray900 Text-fontSize--13 Text-fontWeight--500">Text me with news and updates</span></label></div>
                                </div>
                              </div>
                              <div id="smsNotificationInfo" *ngIf="isSmsNotificationVisible">
                                <label for="smsNotification" class="smsNotifText">
                                  <span class="Checkbox-Label Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">I agree to receive text messages from {{siteMeta?.name}} about my membership, bookings and offers.
                                    Message frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
                                    See our <a class="smsConsentLink" [href]="siteMeta?.privacyPolicyUrl" target="_blank" rel="noopener">Privacy Policy</a>
                                    and <a class="smsConsentLink" [href]="siteMeta?.termsUrl" target="_blank" rel="noopener">Terms</a>.
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <!-- <div class="loading-bg justify-content-center" *ngIf="!isLoading"></div>
                <div class="loading justify-content-center" *ngIf="!isLoading"><img src="assets/images/loading.gif" /></div> -->
                <div class="flex-item width-12">
                  
                </div>
                <div class="PaymentForm-confirmPaymentContainer mt2 flex-item width-grow">
                  <div class="ConfirmPayment">
                    <div class="FormFieldCheckbox TermsOfServiceConsentCheckbox">
                      <div class="CheckboxField">
                        <div class="Checkbox">
                          <div class="Checkbox-InputContainer">
                            <input id="termsOfServiceConsentCheckbox" name="termsOfServiceConsentCheckbox" type="checkbox" class="Checkbox-Input" (change)="onTermsOfServiceChange($event)" />
                          </div>
                          <div><label for="termsOfServiceConsentCheckbox"><span class="Checkbox-Label Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">I agree to {{siteMeta.name}}.'s <a class="Link TermsOfServiceConsentCheckbox-customMessageLink Link--checkout--secondary" href="/assets/pdf/FitnessFactoryHarlem_TermsAndConditions.pdf" target="_blank" rel="noopener">Terms of Service</a> and <a class="Link TermsOfServiceConsentCheckbox-customMessageLink Link--checkout--secondary" href="/assets/pdf/DropFitness_PrivacyPolicy.pdf" target="_blank" rel="noopener">Privacy Policy</a></span></label></div>
                        </div>
                      </div>
                    </div>
                    <div class="AnimateSinglePresence"></div>
                    <div class="flex-item width-12"></div>
                    <div class="row">
                      <div class="col-sm-6">
                        <button class="SubmitButton" type="submit" [disabled]="isButtonDisabled" data-testid="hosted-payment-submit-button" style="background-color: rgb(0, 116, 212); color: rgb(255, 255, 255);">
                          Join Now!
                        </button>
                      </div>
                      <div class="col-sm-6">
                        <button class="SubmitButton" type="button" aria-label="Cancel" data-testid="hosted-payment-submit-button" style="background-color: #dfdfdf; color: #000000;" (click)="closeForm()">
                          Cancel
                        </button>
                      </div>
                    </div>
                    <div class="flex-item width-12">
                      <div class="ConfirmPayment-PostSubmit">
                        <div class="ConfirmTerms">
                          <div class="AnimateSinglePresence"></div>
                          <div class="AnimateSinglePresence">
                            <div class="AnimateSinglePresenceItem ConfirmPaymentTerms">
                              <div>
                                <div class="ConfirmTerms Text Text-color--gray600 Text-fontSize--13" data-testid="ConfirmPaymentTermsText">
                                  <div class="AnimateSinglePresence"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="AnimateSinglePresence"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </main>
        <footer class="App-Footer Footer">
          <div class="Footer-PoweredBy">
            <a class="Link Link--primary" href="https://tech.dropfitness.com" target="_blank" rel="noopener">
              <div class="Footer-PoweredBy-Text Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                Powered by 
                <span>
                  <img class="logo-img" [src]="logo" width="15" />
                </span>
              </div>
            </a>
          </div>
          <div class="CheckoutFooter-links flex-container direction-row">
            <a class="Link CheckoutFooter-link Link--checkout--secondary" [href]="siteMeta.termsUrl" target="_blank" rel="noopener"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Terms</span></a>
            <a class="Link CheckoutFooter-link Link--checkout--secondary" [href]="siteMeta.privacyPolicyUrl" target="_blank" rel="noopener"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Privacy</span></a></div>
        </footer>
      </div>
    </div>
  </div>
  <df-country-select #country (select)="changeCountry($event)"></df-country-select>
</div>